//chapter1
export default {
    id : 17,//chapter number
    title : '17. PFMEA 작성방법 (4) - PFMEA 기능분석과 특성',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c17.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA 기능분석과 특성',
            ],
            body2 : [
                'PFMEA 기능분석과 특성에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '17.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '공정기능은 고장원인을 규정하는 토대가 된다.',//html available
                    answer : "2",
                    explain : '공정기능은 고장형태의 토대가 된다.'
                },
                {
                    type : 'ox',
                    question : '공정 4M 중 사용되는 모든 자재별 기능을 정의한다.',//html available
                    answer : "2",
                    explain : '자재가 아니고 부자재가 대상이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 기능분석 개요</h3>
                        <li>기능은 각 공정단계가 의도하는 것을 묘사함</li>
                        <li>공정단계에는 기능이 주어지며 다수의 기능을 가질 수도 있음</li>
                        <li>기능분석 이전에 공정 요구사항, 제조환경조건, 사이클타임, 안전요구사항 등 정보가 수집될 수 있음</li>
                        <li>기능의 묘사는 명확해야 함</li>
                        <li>측정되는 기능을 묘사하는 “명사”에 이어 “동사”를 사용하는 형태가 추천됨</li>
                        <li>기능은 “현재시제”를 나타내는 동사를 사용해야 함</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <h3>2. P-Diagram 작성방법</h3>
                        <p class="mg10"></p>
                        <h3>3. Effect - Failure Mode - Cause의 구조</h3>
                        <p class="mg10"></p>
                        <h3>4. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c17.mp4',
        },
    ]
}